<!--首页 我绑定的考级中心 考级和资讯-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="row-list" v-for="(order, index) in list" :key="index"
               @click="goDetail(order)">
            <div class="justify-space-flex row-title">
              <div class="title-left flex-start gray">
<!--                <img class="row-title-img" src="https://static.dierqudao.com/images/dinghuoxitong/icon-date.png" alt="">-->
                <span>{{ order.name }}（{{order.phone}}）</span> 
              </div>
              <div v-if="order.registstatus==1" class="title-right gray">
                提交成功，待审核
              </div>

              <div v-else-if="order.registstatus==2" class="title-right green">
                审核成功
              </div>
              <div v-else class="title-right gray">
                审核失败
              </div>
            </div>
            <div class="justify-space-flex row-goods">
              <div class="row-left flex-start">
                <div class="goods-detail">
                  <!--                    <div class="goods-name" v-if="order.member_list.length>0">-->
                  <!--                      <span v-for="(member,mkey)  in order.member_list" v-if="mkey<4" :key="mkey">{{member.name}} </span>-->
                  <!--                      等{{order.members}}人报名-->
                  <!--                    </div>-->
                  <!--                    <div class="goods-name" v-else>-->
                  <!--                      暂无人员报名-->
                  <!--                    </div>-->
                  <div class="goods-weight gray-light">
                    {{ order.danwei }} <br/>
                    <span style="color:#f00" v-if="order.registstatus==3">{{order.registstatusdes}}</span>
                  </div>
                </div>
              </div>
              <!--                <div class="row-right">-->
              <!--&lt;!&ndash;                  <div class="goods-price" v-show="order.order_price>0"><span>¥</span>{{order.order_price}}</div>&ndash;&gt;-->
              <!--                  <div class="goods-num gray-light">人数 {{order.members}}</div>-->
              <!--                </div>-->
            </div>
            <div class="row-btn" v-if="order.registstatus==2">
              <div class="look-order" @click="toEdit(order)">修改信息</div>
              <div class="look-order" @click="toDetail(order)">查看详情</div>
              <!--<div class="invite-btn">邀请好友来拼团</div>-->
            </div>
            <div class="row-btn" v-if="order.registstatus==3">
              <div class="look-order" @click="toEdit(order)">修改信息</div>  
            </div>
          </div>

        </van-list>
      </van-pull-refresh>


    </div>

    <div class="savebtn">

      <van-button 
          style="margin: 0 auto"
          size="normal" round @click="goWenjuan()">大课间情况调查问卷
      </van-button>

      <van-button
        v-if="showClubDakejian"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round v-rblink="{name:'DakejianApplySimple'}">新增申报
      </van-button>
      <van-button
        v-else 
          :disabled="true"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round >您已授牌
      </van-button>
      <!-- <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round @click="add">新增申报
      </van-button> -->
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-pull-refresh {
  /*margin-top: 0.3rem*/
}

.title-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.normal-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.count_edit {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';

import {
  Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button, DropdownMenu, DropdownItem,
  Tab,
  Tabs,
  NoticeBar,
} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
export default {
  name: 'DakejianList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    LoginDialog
  },
  data: function () {
    return {
      loginShow: false,
      active: 0,
      row:{
        club:{
          
        }
      },
      isLoading: false,
      loading: false,
      showClubDakejian: false,
      finished: false,
      params: {
        pageNo: 1,
        pageSize: 10,
        // status: 1
      },
      homeTop: 0,
      list: [],
      noticeList: [],
      userType: 2
    }
  },
  mounted() {
    document.title = "大课间列表"

    let that = this;
    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = 0;
      that.params.pageNo = 1;
      // that.params.status = 0;
      that.loading = true;
      that.finished = false;

      that.params.id = this.$route.query.id;

      that.getList()

      that.fetch()

    }
    document.getElementById('app').scrollTop = this.homeTop || 0
    this.$route.meta.isBack = false;

  },
  destroyed() {
  },
  methods: {
    goWenjuan(){
        appEvent({
          name: "downloadFile",
          query: { url: 'https://qywx.wjx.cn/vm/OyTKhQN.aspx' },
        });
    },
    getList() {
      let that = this;
      that.$api.get('/api/cdakejian/dakejianList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          // 考级
          this.getList()
        }, 500);
      }

    },

    // 考试详情
    goDetail(order) {
      // 判断是否成团
      return
      if (order.score_status == 1) {
        rbLink({
          'name': 'ExameApplyMemberAddFront',
          'query': {
            kaoji_id: order.id,
            share_id: 0
          }
        })
      }
    },

  add(){
    // Toast('本次第五届文化纪大课间申请示范单位已停止申报了哦～')
    // alert('')
  },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    toDetail(record) {
      rbLink({
        name: 'CDakejianDetail',
        query: {
          id: record.id
        }
      })
    },

    toEdit(record) {
      rbLink({
        name: 'DakejianApplySimple',
        query: {
          id: record.id
        }
      })
    },


    // 更改状态
    onStatusChange() {

      let that = this;

      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];
      if (this.active == 0) {
        // 考级
        that.getList()

      } else {
        // 资讯
        that.getNoticeList()
      }


      // that.params.status = index;


      // this.$route.query.status = 0;
    },

    checkDakejian(){
      let that = this;
      that.$api.post(
        "/api/cdakejian/checkdanweishoupai",
        {
          danwei: that.row.club.shenbaodanwei,
        },
        (res) => {
          that.showClubDakejian = false;
        },
        (res) => {
          that.showClubDakejian = true;
          }
      );

    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/user/myclub",
        {},
        (res) => {
          that.row.club = res.data.club;
          that.row.club_list = res.data.club_list;
          that.loading = false; 
          that.checkDakejian()
        },
        (res) => {
          that.loading = false;
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            } 
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
 
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// DakejianList.vue?715ff93a